module.exports = __webpack_public_path__ + "static/avatar-7a66d447287bc700975646ff796ba633.jpg";